import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import {
  selectAllowableLoad,
  selectAllowableTestLoad,
  selectLoadType,
} from "../../../../store/slices/fhwaSlice";
import KiloNewton from "../../../../components/Math/Units/Metric/KiloNewton";
import Kilopound from "../../../../components/Math/Units/Imperial/Kilopound";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import ToolTip, { IconType } from "../../../../components/ToolTip";
import LoadType from "../../Innere/LoadType";
import { TENSION_PILE } from "../../../../constants";

function AllowableLoad() {
  const { t } = useTranslation("fhwa");
  const allowableLoadFormula_c =
    "\\displaystyle \\alpha\\cdot f'_{c} \\cdot A_{grout}\\cdot \\gamma\\cdot F_{y-bar}\\cdot A_{bar}";
  const maximumTestLoadFormula_c =
    "\\displaystyle \\beta\\cdot f'_{c} \\cdot A_{grout} + \\delta\\cdot F_{y-bar} \\cdot A_{bar}";
  const allowableLoadFormula_t = "\\displaystyle \\gamma\\cdot F_{y-bar}\\cdot A_{bar}";
  const maximumTestLoadFormula_t = "\\displaystyle \\delta\\cdot F_{y-bar}\\cdot A_{bar}";

  const allowableLoad = useSelector(selectAllowableLoad);
  const allowableTestLoad = useSelector(selectAllowableTestLoad);
  const loadType = useSelector(selectLoadType);
  const isTension = loadType === TENSION_PILE;
  const formula_allowableLoad = isTension ? allowableLoadFormula_t : allowableLoadFormula_c;
  const formula_maximumLoad = isTension ? maximumTestLoadFormula_t : maximumTestLoadFormula_c;
  return (
    <>
      <RowBody
        titleValue={<p>{t("AllowableLoad")}</p>}
        inputValue={
          <span className="input">
            <NumberFormatText value={allowableLoad.current} decimalScale={2} />
          </span>
        }
        unitValue={<ConvertUnit Metric={<KiloNewton />} Imperial={<Kilopound />} />}
        formulaValue={
          <ToolTip id={"AllowableLoad"} type={IconType.FORMULA} formula={formula_allowableLoad} />
        }
      />
      <RowBody
        titleValue={<p>{t("MaximumTestLoad")}</p>}
        inputValue={
          <span className="input">
            <NumberFormatText value={allowableTestLoad.current} decimalScale={2} />
          </span>
        }
        unitValue={<ConvertUnit Metric={<KiloNewton />} Imperial={<Kilopound />} />}
        formulaValue={
          <ToolTip id={"MaximumTestLoad"} type={IconType.FORMULA} formula={formula_maximumLoad} />
        }
      />
    </>
  );
}

export default AllowableLoad;
